import React from 'react';
import { Label } from 'react-bootstrap';

function getStyle(state) {
  switch (state) {
    case 'DR':
      return 'info';
    case 'AC':
      return 'info';
    case 'AR':
      return 'info';
    default:
      return 'info';
  }
}
function getState(state) {
  switch (state) {
    case 'DR':
      return 'Draft';
    case 'AC':
      return 'Active';
    case 'AR':
      return 'Archived';
    default:
      return '';
  }
}
class TourState extends React.Component {
  render() {
    const state = this.props.state;
    return <Label bsStyle={getStyle(state)} >{getState(state)}</Label>;
  }
}
export default TourState;



// WEBPACK FOOTER //
// src/routes/tours/components/TourState.js